/** Parses a URL query value as a number, or returns `fallback` when absent/empty. */
export function parseQueryNumber(value, fallback) {
  if (value === null || value === undefined || value === "") {
    return fallback;
  }
  return Number(value);
}

/** Parses a URL query value as a number, or `undefined` when absent/empty. */
export function parseOptionalQueryNumber(value) {
  if (value === null || value === undefined || value === "") {
    return undefined;
  }
  return Number(value);
}
